import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-no-permissions',
  templateUrl: './no-permissions.component.html',
  styleUrls: ['./no-permissions.component.scss']
})
export class NoPermissionsComponent implements OnInit {

  constructor(private _router: Router) { }

  ngOnInit() {
  }

  navigateMainPage() {
    this._router.navigate([environment.baseRoute]);
  }

}
